//1.Import
import "@lottiefiles/lottie-player";
import Swiper from 'swiper/bundle';
import Layout from '../Layout';
import PageHeader from "../sections/PageHeader";
import SectionFlow from '../sections/SectionFlow';

//2.Initialization
const layout=new Layout();
const pageHeader=new PageHeader();
const sectionFlow= new SectionFlow();

//3.Events
window.addEventListener('DOMContentLoaded', function() {
    pageHeader.init();
    sectionFlow.init();
});


//4. Functions
let sceneSwiper = new Swiper(".scene__swiper", {
    slidesPerView: 1.1,
    spaceBetween: 10,
    centeredSlides: false,
    loop:true,
    slidesOffsetBefore: 15,
    pagination: {
        el: ".scene .swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".scene .swiper-button-next",
        prevEl: ".scene .swiper-button-prev",
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 30,
            centeredSlides: true,
            slidesOffsetBefore: 0,
        },
        1024: {
            slidesPerView: 3.4,
            spaceBetween: 40,
            autoHeight:false,
            centeredSlides: true,
            slidesOffsetBefore: 0,
        },
    },
});